// One source of geometry for SVG painting and pointer hit testing. Keep the
// original paths, tile sizes and paint attributes so saved patterns look alike.
const node=(tag,props,children)=>({tag,props,...(children?{children}:{})});
const star=Array.from({length:10},(_,i)=>{const a=i*Math.PI/5-Math.PI/2,r=i%2?2.6:6;return`${Math.cos(a)*r},${Math.sin(a)*r}`;}).join(' ');
const tiles={
  plaid:{size:28,art:node('g',{fill:'none',stroke:'color'},[
    node('path',{d:'M0 6H28M0 22H28M6 0V28M22 0V28',strokeWidth:4,opacity:.65}),
    node('path',{d:'M0 10H28M10 0V28',strokeWidth:.8}),
  ])},
  checker:{size:24,art:node('g',{fill:'color'},[node('rect',{width:12,height:12}),node('rect',{x:12,y:12,width:12,height:12})])},
  leopard:{size:30,art:node('g',{fill:'none',stroke:'color',strokeWidth:2,strokeLinecap:'round'},[
    node('path',{d:'M5 4C-1 3 1 13 6 12M10 4C16 3 16 12 11 13M20 22C18 14 30 13 29 20M23 25C25 28 29 26 29 23'}),
    node('ellipse',{cx:8,cy:8,rx:3,ry:3.5,fill:'color',opacity:.3}),
  ])},
  zebra:{size:35,art:node('g',{fill:'color'},[
    node('path',{d:'M0 1Q13 11 35 4V10Q16 13 0 6ZM0 22Q18 10 35 22V27Q16 17 0 27Z'}),
    node('path',{d:'M10 25Q20 29 19 35H14Q14 30 5 28Z'}),
  ])},
  waves:{size:24,art:node('path',{d:'M-6 12Q0 0 6 12T18 12T30 12',fill:'none',stroke:'color',strokeWidth:2})},
  hearts:{size:26,art:node('path',{d:'M13 20C-2 10 9 1 13 9C17 1 28 10 13 20Z',fill:'color'})},
  stars:{size:28,art:node('polygon',{points:star,transform:'translate(14 14)',fill:'color'})},
  stripes:{size:18,art:node('path',{d:'M0 6H18',stroke:'color',strokeWidth:3})},
};
export const PATTERN_PAINT_BOUNDS=Object.freeze({x:-100,y:-150,width:300,height:450});
export function patternTile(type){return tiles[type]||tiles.stripes;}
// A single impression shares its geometry with full-nail patterns and hit tests.
const squareStamp={size:24,art:node('rect',{width:24,height:24,fill:'color'})};
export function patternStampTile(type){return type==='checker'?squareStamp:patternTile(type);}
